














import {
  computed, defineComponent, ref,
} from '@vue/composition-api';
import { useQuery } from '@vue/apollo-composable';
import { useFormat } from '@ideavivat/vivat-2';

import getHolidays from '@/gql/systemCalendar/getHolidays.gql';

const CompanyCalendar = defineComponent({
  props: {
    selectable: {},
    events: {
      type: Array,
      default: () => [],
    },
  },
  setup(props) {
    const calendar = ref(null);
    const calendarStart = ref('');
    const calendarEnd = ref('');
    function handleDatesRender(event: any) {
      calendarStart.value = useFormat.date(event.view.activeStart).computerShortDate();
      calendarEnd.value = useFormat.date(event.view.activeEnd).computerShortDate();
    }
    const filterCalendarDueDate = computed(() => {
      let filterDueDateTemp;
      if (calendarStart.value !== '' && calendarEnd.value !== '') {
        filterDueDateTemp = {
          from: calendarStart.value,
          to: calendarEnd.value,
        };
      }
      return filterDueDateTemp;
    });
    const { result: getHolidaysResult, loading: getHolidaysLoading } = useQuery(getHolidays, computed(() => ({
      filterDateBetween: filterCalendarDueDate.value,
    })), () => ({ fetchPolicy: 'network-only' }));

    const holidays = computed(() => getHolidaysResult?.value?.holidays?.data || []);
    const events = computed(() => holidays.value.map((elm: any) => {
      const color = 'red';
      return {
        id: elm.id,
        title: `${elm.description}`,
        start: elm.date,
        color,
      };
    }));
    const computedEvents = computed(() => ([...events.value as any, ...props.events]));

    return {
      calendar,
      computedEvents,
      handleDatesRender,
    };
  },
});

export default CompanyCalendar;
